import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 727.000000 737.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,737.000000) scale(0.100000,-0.100000)">

<path d="M3220 6390 c-396 -29 -819 -150 -1157 -330 -538 -287 -969 -726
-1250 -1270 -374 -724 -421 -1618 -127 -2385 45 -116 105 -245 115 -245 7 0
102 76 899 720 194 157 450 363 569 459 119 96 299 242 401 324 102 83 316
255 475 383 160 128 358 288 441 356 84 68 252 204 374 303 122 99 231 187
240 195 10 8 55 44 99 79 70 56 100 83 74 68 -82 -49 -3108 -1545 -3113 -1540
-4 4 -3 56 1 115 44 594 346 1165 814 1539 269 215 632 381 960 438 189 34
456 42 636 21 312 -37 624 -145 901 -312 54 -32 100 -58 103 -58 11 0 535 526
535 537 0 13 -92 80 -228 166 -513 323 -1149 481 -1762 437z"/>
<path d="M5401 5431 c-23 -22 -44 -39 -45 -38 -2 1 -58 -40 -125 -91 -72 -55
-119 -98 -115 -104 4 -6 3 -8 -3 -5 -11 7 -83 -41 -125 -84 -14 -15 -28 -26
-30 -24 -2 2 -29 -17 -59 -43 -30 -26 -75 -63 -99 -82 -24 -19 -73 -60 -109
-90 -96 -81 -101 -85 -156 -129 -27 -23 -54 -41 -58 -41 -5 0 -7 -7 -4 -14 4
-11 1 -13 -10 -9 -12 5 -15 2 -11 -9 4 -9 1 -15 -7 -14 -10 1 -233 -176 -353
-282 -15 -13 -43 -35 -62 -50 -19 -15 -43 -34 -52 -42 -9 -8 -75 -62 -147
-120 -75 -61 -128 -111 -126 -118 3 -7 0 -10 -6 -7 -9 6 -48 -19 -94 -61 -11
-11 -47 -41 -80 -69 -33 -27 -64 -55 -68 -62 -4 -7 -13 -13 -19 -13 -5 0 -38
-24 -72 -52 -77 -66 -105 -93 -87 -83 10 5 12 4 7 -4 -4 -6 -11 -9 -16 -6 -5
3 -19 -3 -32 -14 -13 -10 -52 -42 -87 -71 -47 -39 -60 -55 -50 -61 10 -7 8 -8
-7 -7 -14 2 -71 -39 -178 -127 -205 -169 -201 -166 -198 -177 1 -5 -1 -7 -6
-4 -9 6 -51 -23 -93 -62 -13 -13 -50 -44 -81 -69 -32 -24 -58 -48 -58 -54 0
-5 -5 -9 -11 -9 -18 0 -113 -84 -100 -88 6 -2 8 -8 5 -14 -4 -6 -9 -6 -14 3
-6 9 -44 -17 -132 -91 -67 -56 -145 -121 -172 -144 -28 -22 -68 -57 -91 -76
-47 -39 -113 -92 -128 -101 -5 -4 -6 -12 -2 -19 5 -9 4 -11 -4 -6 -10 7 -48
-20 -136 -96 -11 -9 -49 -41 -85 -70 -36 -29 -74 -61 -85 -71 -11 -11 -35 -30
-52 -44 -18 -14 -30 -30 -26 -36 3 -6 1 -7 -6 -3 -7 5 -48 -24 -104 -71 -50
-43 -125 -104 -165 -137 -76 -62 -97 -84 -68 -73 10 4 15 3 11 -4 -4 -5 -14
-8 -23 -5 -23 7 -96 -59 -86 -76 23 -39 120 -168 126 -168 5 0 8 -7 8 -16 0
-10 6 -14 15 -11 8 4 17 1 21 -5 5 -7 2 -8 -6 -3 -43 27 56 -90 202 -238 61
-62 102 -96 109 -91 7 4 9 3 6 -3 -4 -6 14 -28 40 -49 26 -22 55 -47 65 -56
29 -29 67 -50 77 -43 7 3 8 0 5 -9 -3 -9 -1 -16 5 -16 7 0 24 -12 39 -26 50
-47 55 -47 96 2 21 25 34 49 30 56 -4 6 -3 8 3 5 13 -8 74 58 71 75 -2 7 2 12
8 13 6 0 35 29 64 63 43 52 51 66 39 74 -11 8 -11 9 2 5 18 -6 20 -3 127 127
54 67 69 92 60 99 -10 6 -9 7 3 4 10 -3 25 4 35 16 74 87 104 125 104 134 0 7
8 14 18 17 9 3 23 15 30 26 7 12 57 74 110 138 54 64 134 162 179 217 44 55
90 111 102 125 40 46 56 64 141 169 47 58 92 112 100 120 8 9 53 63 100 121
46 58 97 119 111 135 66 74 108 129 103 137 -3 5 -1 7 4 6 5 -2 22 12 37 31
28 32 28 34 10 47 -10 8 -14 14 -9 14 6 0 15 -5 22 -12 6 -6 13 -10 15 -7 1 2
25 31 52 64 28 32 49 65 47 72 -2 7 1 12 7 11 5 -2 127 139 271 312 144 173
269 324 279 335 121 143 170 208 165 216 -3 5 0 8 7 7 6 -2 32 22 56 52 25 30
62 76 83 101 21 25 80 97 131 160 51 63 106 130 123 150 163 193 191 230 176
239 -8 5 -11 12 -7 17 5 4 12 1 17 -6 7 -12 10 -12 22 0 35 37 93 114 90 121
-1 5 2 8 7 8 5 0 40 37 77 83 38 45 73 87 80 92 6 6 28 33 49 60 20 28 49 64
64 80 23 26 56 67 136 164 11 14 35 42 54 63 43 49 35 49 -18 -1z m-91 -105
c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m-60
-70 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z
m-143 -142 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-87 -138
c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m-90
-16 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z
m60 -20 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z
m-439 -213 c-10 -9 -11 -8 -5 6 3 10 9 15 12 12 3 -3 0 -11 -7 -18z m-161
-137 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z
m263 -55 c-3 -9 -8 -14 -10 -11 -3 3 -2 9 2 15 9 16 15 13 8 -4z m-198 -235
c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m-345
-425 c-7 -9 -15 -13 -17 -11 -6 6 20 36 26 30 2 -2 -2 -10 -9 -19z m-70 -45
c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m-610
-30 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z
m550 -74 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10
-4z m-30 -51 c0 -1 -6 -7 -13 -13 -10 -8 -13 -6 -13 7 0 11 6 17 13 14 7 -3
13 -6 13 -8z m-1397 -622 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13
-5z m697 -217 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10
-2 10 -4z m-70 -66 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0
4 -4 4 -10z m-1410 -344 c0 -2 -7 -7 -16 -10 -8 -3 -12 -2 -9 4 6 10 25 14 25
6z m-75 -76 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11
-10z m1062 -102 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-117
-152 c0 -2 -7 -7 -16 -10 -8 -3 -12 -2 -9 4 6 10 25 14 25 6z m-69 -79 c-10
-9 -11 -8 -5 6 3 10 9 15 12 12 3 -3 0 -11 -7 -18z m-1331 -41 c0 -2 -7 -7
-16 -10 -8 -3 -12 -2 -9 4 6 10 25 14 25 6z m1210 -96 c0 -5 -4 -10 -10 -10
-5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"/>
<path d="M5525 4919 l-270 -270 23 -37 c46 -76 146 -280 180 -367 103 -266
146 -504 145 -800 0 -315 -56 -581 -181 -865 -295 -673 -902 -1148 -1627
-1275 -100 -17 -325 -32 -325 -21 0 7 1117 2233 1427 2845 79 156 142 285 141
287 -2 1 -44 -48 -93 -109 -50 -62 -178 -220 -285 -352 -106 -132 -217 -268
-244 -301 -28 -34 -73 -90 -101 -125 -27 -35 -100 -124 -160 -199 -61 -74
-266 -326 -455 -560 -189 -234 -498 -614 -685 -845 -188 -231 -408 -503 -490
-605 -82 -102 -151 -187 -155 -190 -3 -3 -60 -73 -128 -157 l-123 -152 53 -27
c82 -41 286 -120 398 -153 308 -92 541 -126 860 -126 374 1 673 53 1010 176
711 260 1309 802 1636 1484 408 851 389 1828 -52 2665 -55 103 -212 350 -223
350 -3 0 -127 -122 -276 -271z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
